import { Linkedin, Youtube, Mail, ArrowUp } from "lucide-react";
import { PROFILE } from "@/data/content";
import { scrollToId } from "@/hooks/useLenis";

const QUICK = [
  { id: "about", label: "About Me" },
  { id: "books", label: "Books" },
  { id: "journey", label: "Professional Summary" },
  { id: "programs", label: "Programs" },
  { id: "contact", label: "Contact Me" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative border-t border-ink/[0.06] pt-20 pb-10"
      data-testid="site-footer"
    >
      <div className="section-x mx-auto max-w-[1400px]">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="text-[11px] uppercase tracking-[0.32em] text-ink/55 font-mono">
              End Note
            </p>
            <h3 className="mt-4 font-display text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-xl">
              Ship reliable software.{" "}
              <span className="text-ink/40">Train the next generation.</span>
            </h3>
            <button
              onClick={() => scrollToId("hero")}
              className="mt-8 inline-flex items-center gap-2 rounded-full border border-ink/15 bg-ink/[0.03] px-4 py-2 text-sm hover:border-accent-cyan/60"
              data-testid="footer-back-to-top"
            >
              <ArrowUp size={14} /> Back to top
            </button>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.32em] text-ink/55 font-mono">
              Quick Links
            </p>
            <ul className="mt-5 space-y-2.5">
              {QUICK.map((q) => (
                <li key={q.id}>
                  <button
                    onClick={() => scrollToId(q.id)}
                    className="text-ink/70 hover:text-ink transition-colors"
                    data-testid={`footer-link-${q.id}`}
                  >
                    {q.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.32em] text-ink/55 font-mono">
              Elsewhere
            </p>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href={PROFILE.contact.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-ink/75 hover:text-ink transition-colors"
                  data-testid="footer-linkedin"
                >
                  <Linkedin size={15} /> LinkedIn
                </a>
              </li>
              <li>
                <a
                  href={PROFILE.contact.youtube}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-ink/75 hover:text-ink transition-colors"
                  data-testid="footer-youtube"
                >
                  <Youtube size={15} /> YouTube
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${PROFILE.contact.email}`}
                  className="inline-flex items-center gap-2 text-ink/75 hover:text-ink transition-colors"
                  data-testid="footer-email"
                >
                  <Mail size={15} /> {PROFILE.contact.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col md:flex-row md:items-center md:justify-between gap-4 border-t border-ink/[0.06] pt-6">
          <p className="text-xs text-ink/55">
            © {year} Chirag Khimani. Crafted with care.
          </p>
          <p className="text-xs text-ink/55 font-mono">
            v1.0 · chiragkhimani.com
          </p>
        </div>
      </div>
    </footer>
  );
}
